// src/pages/About.jsx
import React from 'react';

export default function About() {
  return (
    <div className="min-h-screen bg-gray-50 text-gray-800">
      {/* Hero section */}
      <div className="relative w-full h-72 bg-cover bg-center" 
           style={{ backgroundImage: "url('/images/casagloria_exterior.jpg')" }}>
        <div className="absolute inset-0 bg-black bg-opacity-40 flex items-center justify-center">
          <h1 className="text-white text-4xl md:text-5xl font-bold tracking-wide">About Casa Gloria</h1>
        </div>
      </div>

      {/* Main content */}
      <div className="max-w-4xl mx-auto p-6 md:p-10 space-y-8">
        {/* Intro */}
        <section>
          <br></br>
          <br></br>
          <h2 className="text-2xl font-semibold mb-3">Nuestra Historia:</h2>
          <p className="text-lg leading-relaxed">
            Casa Gloria comenzó desde la curiosidad de: ¿Que pasaría si iniciáramos un nuevo proyecto?, y poner en práctica todas las cosas que nos gustarían replicar en cada viaje vivido, también desde el Valor de retomar lo que por mucho tiempo había estado abandonado, y desde la necesidad de generar empleos y sentirnos productivos. 
          </p>
        </section>

        {/* Mission and Values */}
        <section>
          <h2 className="text-2xl font-semibold mb-3">Mision:</h2>
          <ul className="list-disc pl-6 space-y-2 text-lg leading-relaxed">
            <li>“Nuestra misión es ofrecer a nuestros invitados una estancia cómoda, impecable y de calidad, nuestro compromiso está en ofrecer un servicio excepcional, cuidando el medio ambiente. Así como contribuir a la economía de nuestro pueblo impulsando y apoyando a los micro negocios.”</li>
          
            
          </ul>
        </section>

        {/* Location */}
        <section>
          <h2 className="text-2xl font-semibold mb-3">Ubicación:</h2>
          <p className="text-lg leading-relaxed">
           Ubicada en una zona tranquila cerca de carretera hacia Querétaro, Casa Gloria está rodeada de calles empedradas,
            casas coloridas y mercados tradicionales. Es el lugar perfecto para relajarse, disfrutar de los sabores locales
            y explorar los sitios culturales que la rodean.
          </p>
          <div className="mt-4">
            <iframe
              title="Casa Gloria Map"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2148.109275683953!2d-99.89758240351779!3d20.530098809535087!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85d39def096c2c29%3A0xffee9cca9e06bb61!2sCasa%20Gloria%20Tequisquiapan!5e0!3m2!1ses!2sie!4v1762449276787!5m2!1ses!2sie"
              width="100%"
              height="250"
              style={{ border: 0 }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
            ></iframe>
          </div>
        </section>

        {/* Contact */}
        <section className="border-t border-gray-300 pt-6">
          <h2 className="text-2xl font-semibold mb-3">Contact Us</h2>
          <p className="text-lg leading-relaxed">
            Hola que tal! porfavor no dudes en contactarnos para cualquier duda o comentario. Estamos aquí para ayudarte a planear tu estadía perfecta en Casa Gloria.:
          </p>
          <ul className="mt-2 space-y-1 text-lg">
            <li><strong>Phone:</strong> +52 427 1635 602</li>
            <li><strong>Email:</strong> vivianaseni@outlook.com</li>
            <li><strong>Address:</strong> Calle Olivos 16, Tequisquiapan. Querétaro, México</li>
          </ul>
        </section>
      </div>
    </div>
  );
}
